angular.module('env.data.models.actionModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("ActionModel",
            {
                extend: ['BaseModel'],
                fields: {
                    nameResource: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    code: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    step: {
                        type: RepresentationModelFieldTypes.STRING
                    }
                }
            }
        );
    })

;